export enum InfoAdditionnelleEnum {
  decompte = 'Décompte',
  dpeCE = 'DPE CE',
  depGES = 'DPE GES'
}
